export const segmentAnalyticsPageView = (url: string) => {
  (window as any).analytics?.page({ url });
};

export const segmentAnalyticsTrack = (name: string, properties: any) => {
  (window as any).analytics?.track(name, properties);
};

export const segmentAnalyticsIdentify = (userId: string, properties: any) => {
  (window as any).analytics?.identify(userId, properties);
};

export function loadSegmentScript(key: string) {
  if (process.env.NODE_ENV === 'development') {
    return;
  }

  (function () {
    // Create a queue, but don't obliterate an existing one!
    const analytics = ((window as any).analytics = (window as any).analytics || []);
    // If the real analytics.js is already on the page return.
    if (analytics.initialize) return;
    // If the snippet was invoked already show an error.
    if (analytics.invoked) {
      if (window.console && console.error) {
        console.error('Segment snippet included twice.');
      }
      return;
    }
    // Add a version to keep track of what's in the wild.
    analytics.SNIPPET_VERSION = '1.0.0';
    analytics._writeKey = key;
    analytics._cdn = 'https://cdn-staging.yanovis.com/analytics';
    // Invoked flag, to make sure the snippet
    // is never invoked twice.
    analytics.invoked = true;
    // A list of the methods in Analytics.js to stub.
    analytics.methods = [
      'identify',
      'reset',
      'track',
      'ready',
      'alias',
      'debug',
      'page',
      'once',
      'off',
      'on',
    ];
    // Define a factory to create stubs. These are placeholders
    // for methods in Analytics.js so that you never have to wait
    // for it to load to actually record data. The `method` is
    // stored as the first argument, so we can replay the data.
    analytics.factory = function (method: any) {
      return function () {
        // eslint-disable-next-line prefer-rest-params
        const args = Array.prototype.slice.call(arguments);
        args.unshift(method);
        analytics.push(args);
        return analytics;
      };
    };
    // For each of our methods, generate a queueing stub.
    for (let i = 0; i < analytics.methods.length; i++) {
      const key = analytics.methods[i];
      analytics[key] = analytics.factory(key);
    }
    // Define a method to load Analytics.js from our CDN,
    // and that will be sure to only ever load it once.
    analytics.load = function (options: any) {
      // Create an async script element based on your key.
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://cdn-staging.yanovis.com/analytics/v1/browser/' + 'standalone.js';
      // Insert our script next to the first script element.
      const first = document.getElementsByTagName('script')[0];
      first.parentNode?.insertBefore(script, first);
      analytics._loadOptions = options;
    };

    // Load Analytics.js with your key, which will automatically
    // load the tools you've enabled for your account. Boosh!
    analytics.load();

    // // Make the first page call to load the integrations. If
    // // you'd like to manually name or tag the page, edit or
    // // move this call however you'd like.
    analytics.page();
  })();
}
